import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  deleteCartId,
  getCart,
  getOrderHistory,
  increaseDecrease,
} from "../Services/Service";
import UserContext from "../context/UserContext";
import axios from "axios";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import BottomLogin from "./bottomLogin";
import { SatelliteIcon } from "evergreen-ui";
import { Copy, Check } from "lucide-react";

const initialValue = {
  discountedTotal: "",
  cartTotal: "",
  totalProducts: "",
  totalQuantity: "",
  userId: "",
  id: "",
};
const initialCart = {
  showCart: "N",
};

const ItemDetails = () => {
  const nav = useNavigate();
  const location = useLocation().state;
  // console.log(location)

  const [cartData, setCartData] = useState([]);
  const [issOpen, setsOpen] = useState();
  const [showCartData, setShowCartData] = useState("Y");
  const [price, setPrice] = useState(initialValue);
  const [time, setTime] = useState(false);
  const [codeCopied, setCodeCopied] = useState(false);
  const { state, update } = useContext(UserContext);

  useEffect(() => {
    if (!location) {
      return nav("/home", { replace: true });
    }
  }, []);

  const fetchOrderHistoryList = async () => {
    getOrderHistory()
      .then((res) => {
        if (res.data.status === 1) {
          setShowCartData("Y");
        } else {
          setShowCartData("N");
        }
        return res.data.data;
      })
      .then((res) => {
        const arr = res.map((data) => {
          return { ...data, show: false };
        });
        setCartData(arr);
      });
  };

  const handleClick = (e) => {
    // set
    const arr = cartData;
    arr[e.target.id].show = !arr[e.target.id].show;
    // console.log(arr)
    setCartData([...arr]);
  };

  const [isOpen, setOpen] = useState(false);

  const toggleClass = () => {
    setOpen(!isOpen);
  };

  const handleCopyCode = (code, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (code) {
      navigator.clipboard.writeText(code);
      setCodeCopied(true);
      setTimeout(() => setCodeCopied(false), 2000);
    }
  };

  // Function to parse redeemSteps and make URLs clickable
  const formatRedeemSteps = (text) => {
    if (!text) return text;

    // Regular expression to match URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
      // Check if the part matches URL pattern (create new regex for each test)
      if (/^https?:\/\/[^\s]+$/.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.stopPropagation();
            }}
            onMouseDown={(e) => {
              e.stopPropagation();
            }}
            style={{
              color: "#14b1ef",
              textDecoration: "underline",
              wordBreak: "break-all",
            }}
          >
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="content-apps mt-5">
      <HelmetProvider>
        <Helmet>
          <title>Orders</title>
        </Helmet>
      </HelmetProvider>
      <div className="container">
        <div className="item-details mt-5">
          <div className="row mt-5 ">
            <div className="col-lg-7">
              <div className="card order-list">
                <div className="card-head">
                  <p className="small m-2">
                    Order placed on:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.orderDate}
                    </span>
                  </p>
                  <p className="small m-2">
                    Order ID:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.orderId}
                    </span>
                  </p>
                  <p className="small m-2">
                    Sub Order ID:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.subOrderId}
                    </span>
                  </p>
                </div>
                <div
                  className="card-body ps-0"
                  onClick={() => {
                    location.isChakraProduct === "Y"
                      ? nav(`/chakra/productdetails/${location?.productId}`)
                      : nav(`/productdetails/${location?.productId}`);
                  }}
                >
                  <div className="d-flex mb-2">
                    <img src={location?.productImage[0]} alt="" />
                    <p>
                      {location?.productTitle}
                      <br />
                      {/* <span>₹{location?.finalAmount}</span> */}
                    </p>
                  </div>
                  <p className="small m-2">
                    Status:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.userOrderStatus != undefined
                        ? location?.userOrderStatus
                        : "--"}
                    </span>
                  </p>
                  <p className="small m-2">
                    AWB Number:{" "}
                    <span className="text-white-50 small">
                      {" "}
                      {location?.awbNumber != undefined
                        ? location?.awbNumber
                        : "--"}
                    </span>
                  </p>
                  <p className="small m-2">
                    Quantity:{" "}
                    <span className="text-white-50 small">
                      {location?.quantityOrdered}
                    </span>
                  </p>
                  <div className="OrderBy_cancelss d-flex justify-content-between align-items-center">
                    <p className="m-0">
                      {location?.finalAmount} SpiceGold coins have been used
                    </p>
                    <div className="mytooltip position-relative">
                      <i onClick={toggleClass} class="fa fa-info-circle"></i>
                      <span
                        className={`position-absolute ${
                          isOpen ? "d-block" : "d-none"
                        }`}
                      >
                        <p className="m-0">
                          SpiceGold are reversed in case of order cancellations
                          or returns..
                        </p>
                      </span>
                    </div>
                  </div>

                  {location?.digital && (
                    <div className="OrderDetailsHeader__base">
                      {location?.productCategory !==
                        "c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" &&
                        location?.digital["Activation Code"] && (
                          <div className="OrderDetailsHeader__orderPlacedHolder">
                            <div className="OrderDetailsHeader__labelHeader">
                              Activation Code :
                            </div>
                            <div
                              className="OrderDetailsHeader__dataInformationText d-flex align-items-center"
                              style={{ gap: "8px", fontSize: "15px" }}
                            >
                              <span>
                                {location?.digital["Activation Code"]}
                              </span>
                              <span
                                onClick={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                                onMouseDown={(e) => {
                                  e.preventDefault();
                                  e.stopPropagation();
                                }}
                                style={{ display: "inline-flex" }}
                              >
                                {codeCopied ? (
                                  <Check
                                    size={16}
                                    color="green"
                                    style={{
                                      cursor: "pointer",
                                      verticalAlign: "middle",
                                    }}
                                    title="Copied!"
                                  />
                                ) : (
                                  <Copy
                                    size={16}
                                    style={{
                                      cursor: "pointer",
                                      color: "#ffd54f",
                                      verticalAlign: "middle",
                                    }}
                                    onClick={(e) =>
                                      handleCopyCode(
                                        location?.digital["Activation Code"],
                                        e
                                      )
                                    }
                                    title="Copy code"
                                  />
                                )}
                              </span>
                            </div>
                          </div>
                        )}
                      <div className="OrderDetailsHeader__orderIdHolder OrderDetailsHeader__orderPlacedHolder">
                        <div className="OrderDetailsHeader__labelHeader">
                          Digital Order ID :
                        </div>
                        <div className="OrderDetailsHeader__dataInformationText">
                          {location?.digital["Digital OrderId"]}
                        </div>
                      </div>
                      {location?.productCategory !==
                        "c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && (
                        <div>
                          <div className="OrderDetailsHeader__labelHeader">
                            Serial No :
                          </div>
                          <div className="OrderDetailsHeader__dataInformationText">
                            {location?.digital["Serial No"]}
                          </div>
                        </div>
                      )}
                      {location?.productCategory !==
                        "c3NjT1RON2UzRzI5dVVSOUJBSDhGdz09" && (
                        <div>
                          {
                            <div className="OrderDetailsHeader__labelHeader">
                              Validity :
                            </div>
                          }
                          <div className="OrderDetailsHeader__dataInformationText">
                            {location?.digital["Validity"]}
                          </div>
                        </div>
                      )}

                      {location?.digital["Redeem Steps"] && (
                        <div className="mt-2">
                          <p
                            // className="mb-1"
                            style={{
                              color: "#ffd54f",
                              marginBottom: "0px",
                            }}
                          >
                            <strong>Redeem Instructions:</strong>
                          </p>{" "}
                          <p
                            className="small"
                            style={{
                              color: "#fff",
                              lineHeight: "1.5",
                              marginBottom: "0px",
                            }}
                          >
                            1. Copy the code above.
                          </p>
                          <p
                            className="small"
                            style={{
                              color: "#fff",
                              lineHeight: "1.5",
                              marginBottom: "0px",
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            2. Visit{" "}
                            <a
                              href="https://leverageedu.com/leveragexfaug/"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              https://leverageedu.com/leveragexfaug
                            </a>
                            .
                          </p>
                          <p
                            className="small"
                            style={{
                              color: "#fff",
                              lineHeight: "1.5",
                              marginBottom: "0px",
                            }}
                          >
                            3. Click on "Book Your Counselling Session".
                          </p>
                          <p
                            className="small"
                            style={{
                              color: "#fff",
                              lineHeight: "1.5",
                              marginBottom: "0px",
                            }}
                          >
                            4. Paste the code, Fill the form, and schedule the
                            event to confirm your Counselling Session.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                <div
                  className="details-footer"
                  onClick={(e) => {
                    e.stopPropagation();
                    nav("/faq");
                  }}
                >
                  <Link
                    to="/faq"
                    className="d-flex justify-content-between align-items-center text-white small"
                  >
                    <p className="m-0">Help & Support</p>
                    <i class="fa fa-chevron-right"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-5 mb-5 mt-3">
              <div className="card order-list mb-5">
                <div className="card-head border-bottom pb-3">
                  <h4>Payment Details</h4>
                </div>
                <div className="card-body ps-0">
                  <table className="table table-borderless text-white">
                    <tbody>
                      {location.productId !==
                        "VW9TUlFaNU9nUlRvTTV3LzNnbSs1Zz09" && (
                        <tr className="small text-white-50">
                          <td>Item Price</td>
                          <td className="text-end">₹ {location?.itemPrice}</td>
                        </tr>
                      )}
                      <tr className="small text-white-50">
                        <td>Delivery & Shipping Charges</td>
                        <td className="text-end">
                          ₹ {location.shippingAmount}
                        </td>
                      </tr>
                      {/* {location.productId !==
                        "VW9TUlFaNU9nUlRvTTV3LzNnbSs1Zz09" && (
                        <tr className="small text-white-50">
                          <td>Discount</td>
                          <td className="text-end">
                            - {location?.discountAmount}{" "}
                            <img
                              src={"/assets/images/spicegold.png"}
                              alt=""
                              className="mr-0"
                              style={{
                                height: "20px",
                                width: "20px",
                                // marginRight: "1px !important",
                              }}
                            />
                          </td>
                        </tr>
                      )}
                      */}
                      {/* <tr className="small text-white-50">
                        <td>Coupon</td>
                        <td className="text-end">-₹ 0</td>
                      </tr> */}
                      <tr>
                        <td style={{ fontSize: "16px" }}>Total Price</td>
                        <td className="text-end" style={{ fontSize: "16px" }}>
                          {" "}
                          {Number(location?.finalAmount) +
                            Number(location.shippingAmount)}{" "}
                          <img
                            src={"/assets/images/spicegold.png"}
                            alt=""
                            className="mr-0"
                            style={{
                              height: "20px",
                              width: "20px",
                              // marginRight: "1px !important",
                            }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="details-footer">
                    <h4 className="fs-6 mb-2">Delivery Address:</h4>
                    <p className="text-white-50 small">
                      <p>
                        {location?.name}, {location?.address}{" "}
                        {location?.landmark} {location?.city}, {location?.state}
                        , {location?.pinCode}
                      </p>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ItemDetails;
